interface SimpleBarProps {
  percentage?: number
  width?: number
  backgroundColor?: string
}

export const SimpleBar = ({
  percentage = 100,
  width = 4,
  backgroundColor = 'black',
}: SimpleBarProps) => {
  return (
    <div className={`relative flex h-full`}>
      <div
        className="w-full"
        style={{
          backgroundColor,
          height: `${100 / percentage}%`,
        }}
      ></div>
    </div>
  )
}
